import { FC} from "react";
import { ModalType, NewPracticeType } from "./types";
import { formatPhoneNumber } from "src/helpers";


const Modal: FC<ModalType> = ({ title, data, onClick }): JSX.Element => {
    const overFlowBackground = ()=>{
      document.body.style.overflow = 'unset';

    }
  return (
    <div className= {`modal fade  loader-index ${title && title.length > 0 ? 'show show-modal' : ''}`} id="typeModal" aria-labelledby="typeModalLabel" aria-hidden="true" >
      <div className="modal-dialog modal-dialog-scrollable modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title" id="typeModalLabel" style={{color: '#008853', fontSize:'1.875rem'}}>{title}</h4>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={
              ()=>{
                onClick()
                overFlowBackground()
                }
               }>
               </button>
          </div>
          <div className="modal-body p-0">
            {title === "New Practices" ?
              <table className="table table-striped table-hover table-responsive position-relative m-0">
                <thead className="sticky-top text-center">
                  <tr>
                    <th scope="col" className="fs-6">Name</th>
                    <th scope="col" className="text-center fs-6">State</th>
                    <th scope="col" className="fs-6 text-center col-3">Phone</th>
                  </tr>
                </thead>
                <tbody className={"text-center"}>
                  {
                    data && data.length > 0 ?
                      data.map((item, index) =>
                        <tr key={index}>
                          <td className="text-17 text-wrap text-break">{item.name}</td>
                          <td className="text-center text-17">{item.state}</td>
                          {item.phone ? <td className="text-center text-17">{formatPhoneNumber(item?.phone)}</td> : <td></td>}
                        </tr>
                      )
                      : null
                  }
                </tbody>
              </table>
              :
              <table className="table table-hover table-striped table-responsive m-0">
                <thead className="sticky-top text-center">
                  <tr>
                    <th className="fs-6" style={{minWidth:'135px'}}>Name</th>
                    <th className="fs-6" style={{minWidth:'135px'}}>Practice</th>
                    <th className="text-center fs-6">State</th>
                    <th className="text-center fs-6" style={{minWidth:'135px'}}>Phone</th>
                  </tr>
                </thead>
                <tbody className={"text-center"}>
                    {
                      data && data.length > 0 ?
                        data.map((item, index) =>
                        <tr key={index}>
                          <td className="text-17 text-wrap text-break">{item.name} </td>
                          <td className="text-17">{(item as NewPracticeType).practice} </td>
                          <td className="text-center text-17">{item.state}</td>
                          {item?.phone ? <td className="text-center text-17">{formatPhoneNumber(item?.phone)}</td> : <td></td>}
                        </tr>
                        )
                        : null
                    }
                </tbody>
              </table>
            }
          </div>
        </div>
      </div>
    </div>



  );
};

export default Modal;
